// Copyright © 2025 Neosocios - Seguimiento De Conversiones

document.addEventListener("DOMContentLoaded", function () {
  // ==========================================
  // MÓDULO 1: CART ATTRIBUTES (CHECKOUT ESTÁNDAR)
  // ==========================================
  (function initCartAttributes() {
    "use strict";

    // Función para obtener el valor de un parámetro URL
    function getURLParameter(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || "";
    }

    // Función para obtener el valor de una cookie
    function getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      return match ? match[2] : null;
    }

    // Función para obtener el último fragmento después del punto de _gcl_aw
    function getGclidFromCookie() {
      const gclAw = getCookie("_gcl_aw");
      if (gclAw) {
        const parts = gclAw.split(".");
        return parts[parts.length - 1] || "";
      }
      return "";
    }

    // Función para recopilar datos de tracking
    function getTrackingData() {
      return {
        source: getURLParameter("utm_source"),
        medium: getURLParameter("utm_medium"),
        campaign: getURLParameter("utm_campaign"),
        term: getURLParameter("utm_term"),
        content: getURLParameter("utm_content"),
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
        ttp: getCookie("_ttp"),
        ttclid: getCookie("ttclid"),
        gclid: getGclidFromCookie(),
      };
    }

    // Verificar si tracking_updated está en false o no existe en sessionStorage
    const trackingUpdated = sessionStorage.getItem("tracking_updated");

    if (trackingUpdated !== "true") {
      // Agregar delay de 2 segundos para garantizar que otros procesos del tema se ejecuten primero
      setTimeout(function () {
        // Recopilar todos los valores
        const trackingData = getTrackingData();

        // Construir el objeto attributes solo con valores existentes
        // Los parámetros UTM van con primera letra mayúscula
        const attributes = {};

        // Agregar atributo de verificación de Neosocios SIEMPRE
        attributes.Neosocios = "true";

        // Agregar demás atributos solo si existen
        if (trackingData.source) attributes.Source = trackingData.source;
        if (trackingData.medium) attributes.Medium = trackingData.medium;
        if (trackingData.campaign) attributes.Campaign = trackingData.campaign;
        if (trackingData.term) attributes.Term = trackingData.term;
        if (trackingData.content) attributes.Content = trackingData.content;
        if (trackingData.fbp) attributes.fbp = trackingData.fbp;
        if (trackingData.fbc) attributes.fbc = trackingData.fbc;
        if (trackingData.ttp) attributes.ttp = trackingData.ttp;
        if (trackingData.ttclid) attributes.ttclid = trackingData.ttclid;
        if (trackingData.gclid) attributes.gclid = trackingData.gclid;

        // Actualizar los note_attributes del carrito usando la API de Shopify
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ attributes }),
        })
          .then((response) => {
            if (response.ok) {
              console.log("Neosocios: Cart attributes updated successfully");
              // Establecer tracking_updated en true en sessionStorage
              sessionStorage.setItem("tracking_updated", "true");
            }
            return response.json();
          })
          .then((data) => {
            console.log("Neosocios: Updated cart ", data);
          })
          .catch((error) => {
            console.error("Neosocios: Error updating cart attributes:", error);
          });
      }, 2000); // Delay de 2 segundos
    }
  })();

  // ==========================================
  // MÓDULO 2: EVENT LISTENERS PARA TRACKING
  // ==========================================
  (function initEventTracking() {
    "use strict";

    // Helper: Safe Log
    function safeLog(msg, data) {
      if (window.console && console.log) {
        console.log(`Neosocios: ${msg}`, data || '');
      }
    }

    // Event: AddToCart - Cuando se agrega producto al carrito
    document.addEventListener('product:addedToCart', function (e) {
      try {
        const data = e.detail || {};

        // Validation: Ensure valid data (prevent crashes if values missing)
        if (!data.product_price) data.product_price = 0;
        if (!data.currency) data.currency = window.Shopify?.currency?.active || 'COP';

        // Facebook Pixel
        if (typeof fbq !== 'undefined') {
          fbq('track', 'AddToCart', {
            content_ids: [String(data.product_id || '')],
            content_name: String(data.product_name || 'Product'),
            content_type: 'product',
            value: Number(data.product_price),
            currency: String(data.currency),
            contents: [{
              id: String(data.variant_id || ''),
              quantity: Number(data.quantity || 1),
              item_price: Number(data.product_price)
            }]
          });
          safeLog('FB AddToCart tracked', data.product_name);
        }

        // Google Analytics 4
        if (typeof gtag !== 'undefined') {
          gtag('event', 'add_to_cart', {
            currency: String(data.currency),
            value: Number(data.product_price),
            items: [{
              item_id: String(data.product_id || ''),
              item_name: String(data.product_name || ''),
              item_category: String(data.product_category || ''),
              price: Number(data.product_price),
              quantity: Number(data.quantity || 1)
            }]
          });
          safeLog('GA AddToCart tracked', data.product_name);
        }
      } catch (err) {
        console.error('Neosocios: Error tracking AddToCart', err);
      }
    });

    // Event: Search - Cuando se realiza búsqueda
    document.addEventListener('catalog:searched', function (e) {
      try {
        const data = e.detail || {};
        const query = String(data.search_query || '');

        if (typeof fbq !== 'undefined') {
          fbq('track', 'Search', { search_string: query });
          safeLog('FB Search tracked', query);
        }

        if (typeof gtag !== 'undefined') {
          gtag('event', 'search', { search_term: query });
          safeLog('GA Search tracked', query);
        }
      } catch (err) {
        console.error('Neosocios: Error tracking Search', err);
      }
    });

    // Event: Filter - Cuando se aplica filtro
    document.addEventListener('catalog:filtered', function (e) {
      try {
        const data = e.detail || {};
        const filterVal = String(data.filter_value || '');

        if (typeof fbq !== 'undefined') {
          fbq('track', 'ViewCategory', {
            content_category: filterVal,
            content_type: 'product_group'
          });
          safeLog('FB Filter tracked', filterVal);
        }

        if (typeof gtag !== 'undefined') {
          gtag('event', 'view_item_list', { item_list_name: filterVal });
          safeLog('GA Filter tracked', filterVal);
        }
      } catch (err) {
        console.error('Neosocios: Error tracking Filter', err);
      }
    });

    // Event: WhatsApp Click
    document.addEventListener('whatsapp:clicked', function (e) {
      try {
        // Facebook Pixel (Contact Event)
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Contact', {
            content_name: 'WhatsApp Button',
            status: 'initiated'
          });
          safeLog('FB Contact tracked - WhatsApp');
        }

        // Google Analytics 4
        if (typeof gtag !== 'undefined') {
          gtag('event', 'generate_lead', {
            currency: window.Shopify?.currency?.active || 'COP',
            value: 0,
            event_category: 'Contact',
            event_label: 'WhatsApp'
          });
          safeLog('GA generate_lead tracked - WhatsApp');
        }
      } catch (err) {
        // Safe fail - don't crash pixel helper
        console.error('Neosocios: Error tracking WhatsApp', err);
      }
    });

    console.log('Neosocios: Event tracking listeners initialized (Safe Mode)');
  })();
});
